import { gql } from 'graphql-request';

export default gql`query($filter: AttributesInput) {
  attributes(filter: $filter) {
    items {
        name
        value
        values
    }
  }
}`;